import { FeatureFlagsContract } from '@terra/shared-contracts-feature-flags';
import { createTerraOrpcClient } from '@terra/shared-utils';

const SERVICE_NAME = 'orchestrator';

export const featureFlagsClient = createTerraOrpcClient({
  contract: FeatureFlagsContract,
  serviceName: SERVICE_NAME,
});
